<template>
  <div class="user-avatar">
    <img v-if="avatarUrl" :src="avatarUrl" alt="" />
    <div v-else class="avatar-placeholder">
      {{ firstChar }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'Avatar',
  data() {
    return {
      userInfo: { name: '平台管理员', avatar: '' }
    }
  },
  computed: {
    avatarUrl() {
      return this.userInfo.avatar || ''
    },
    firstChar() {
      const name = this.userInfo.name || '?'
      return name.charAt(0).toUpperCase()
    }
  }
}
</script>

<style lang="scss" scoped>
.user-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.avatar-placeholder {
  width: 100%;
  height: 100%;
  background: #2C68FF;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
}
</style>
